import { FC, useEffect, useState } from 'react';
import { Icon } from 'common-components';
import classNames from 'classnames';
import { FloatingProgressTypes } from './floatingProgressTypes';
import styles from './floatingProgress.module.scss';
import ProgressBar from '../../progressBar/progressBar';
import RadialProgress from '../radialProgress/radialProgress';
import useResizeObserver from '../../useResizeObserver';

const FloatingProgress: FC<FloatingProgressTypes> = (props: FloatingProgressTypes) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [isExpandedVisible, setIsExpandedVisible] = useState<boolean>(false);
    const { height: condensedHeight, width: condesedWidth, resizedContainerRef: condesedRef } = useResizeObserver();
    const { height: expandedHeight, resizedContainerRef: expandedRef } = useResizeObserver();
    const PADDING_OFFSET = 16;

    useEffect(() => {
        if (isExpanded) {
            const interval = setInterval(() => {
                setIsExpandedVisible(true);
            }, 200);
            return () => clearInterval(interval);
        }
        return setIsExpandedVisible(false);
    }, [isExpanded]);

    const {
        percentage,
        topOffset,
        bottomOffset,
        rightOffset,
        leftOffset,
        expansionHeader,
        expansionSubHeader,
        progressColor = '#FB86B6',
        progressBGColor = '#C9BAE1'
    } = props;

    return (
        <div
            className={styles['floating-progress-container']}
            data-testid="floating-progress"
            style={{
                bottom: `${bottomOffset}rem` || undefined,
                right: `${rightOffset}rem` || undefined,
                left: `${leftOffset}rem` || undefined,
                top: `${topOffset}rem` || undefined
            }}
        >
            <div
                className={classNames(
                    styles['transition-container'],
                    isExpanded ? styles['expanded-progress'] : styles['condensed-progress']
                )}
                style={
                    isExpanded
                        ? { width: '25rem', height: expandedHeight + PADDING_OFFSET }
                        : { width: condesedWidth + PADDING_OFFSET, height: condensedHeight + PADDING_OFFSET }
                }
            >
                {isExpanded ? (
                    <div
                        data-testid="expanded-progress"
                        className={classNames(styles['progress-bar-container'])}
                        ref={expandedRef}
                        style={{ opacity: isExpandedVisible ? 1 : 0 }}
                    >
                        <div className={styles['progress-bar-content']}>
                            <div className={styles['content-text']}>
                                {expansionHeader && <div className={styles.header}>{expansionHeader}</div>}
                                {expansionSubHeader && <div style={{ maxWidth: '30rem' }}>{expansionSubHeader}</div>}
                            </div>
                            <div className={styles['horizontal-separator']} />
                            <div className={styles['progress-bar']}>
                                <ProgressBar
                                    direction="horizontal"
                                    value={percentage}
                                    bgColor={progressBGColor}
                                    valueColor={progressColor}
                                />
                                <span>{percentage}%</span>
                            </div>
                        </div>
                        <div className={styles['condense-btn-container']}>
                            <Icon
                                data-testid="condense-btn"
                                onClick={() => setIsExpanded(!isExpanded)}
                                name={'chevronRightWhite'}
                                className={styles['expand-btn']}
                                style={{ transform: 'rotate(-180deg)', width: '2rem', height: '2rem' }}
                            />
                        </div>
                    </div>
                ) : (
                    <div data-testid="condensed-progress" className={styles['radial-progress']} ref={condesedRef}>
                        {percentage < 100 ? (
                            <RadialProgress percentage={percentage} radius={1.8} />
                        ) : (
                            <Icon name="pinkCheck" />
                        )}
                        <span>{percentage}%</span>
                        <div className={styles.separator} />
                        <Icon
                            data-testid="expanse-btn"
                            onClick={() => setIsExpanded(!isExpanded)}
                            name={'chevronRightWhite'}
                            className={styles['expand-btn']}
                            style={{ width: '2rem', height: '2rem' }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default FloatingProgress;
